var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.333 0c-1.588 0-2.89 1.318-2.89 2.924v3.658c0 .042.004.085.011.127A2.18 2.18 0 000 8.771v8.037C0 18.023.966 19 2.167 19h8.666C12.034 19 13 18.023 13 16.808V8.771a2.18 2.18 0 00-1.454-2.062.753.753 0 00.01-.127V2.924c0-1.606-1.3-2.924-2.888-2.924H4.333zm0 1.463H8.67c.812 0 1.444.64 1.444 1.461V6.58H2.888V2.924c0-.822.633-1.46 1.446-1.46zm2.154 8.76a.718.718 0 01.522.211.73.73 0 01.213.525v2.925a.726.726 0 01-.722.714.727.727 0 01-.722-.714v-2.925a.726.726 0 01.71-.737z",
    fill: "#DAE3ED",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.9213d8d6.svg";
export { ForwardRef as ReactComponent };